import React from "react";
import Layout from "../../components/layout";

const Setupnewclient = () => {
  return <>Setupnewclient</>;
};

export default Setupnewclient;
